import React from "react";
import Urgent from "../../assets/icons/Icon-Priority-Urgent-32px.svg";
import High from "../../assets/icons/Icon-Priority-High-32px.svg";
import Medium from "../../assets/icons/Icon-Priority-Medium-32px.svg";
import Low from "../../assets/icons/Icon-Priority-Low-32px.svg";

const Priority = ({ priority }) => {
  switch (priority) {
    case "Urgent":
      return <img src={Urgent} alt="Urgent Priority" />;
    case "High":
      return <img src={High} alt="High Priority" />;
    case "Medium":
      return <img src={Medium} alt="Medium Priority" />;
    case "Low":
      return <img src={Low} alt="Low Priority" />;
    default:
      return <img src={Medium} alt="Medium Priority" />;
  }
};

export default Priority;